import { render, staticRenderFns } from "./ButtonBase.vue?vue&type=template&id=47b6fd39&scoped=true&"
var script = {}
import style0 from "./ButtonBase.vue?vue&type=style&index=0&id=47b6fd39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6fd39",
  null
  
)

export default component.exports